import {Component, OnInit} from '@angular/core';
import {defaultLanguage, languageList} from "../../../../assets/config/config";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss']
})
export class LanguageSwitcherComponent implements OnInit{
  availableLanguages = languageList;
  selectedLanguage = '';
  defaultLanguage = defaultLanguage;

  constructor(private _translateService: TranslateService) {
    this._translateService.setDefaultLang(this.defaultLanguage);
    this._translateService.use(this.defaultLanguage);
  }

  ngOnInit() {
    this.selectedLanguage = this.defaultLanguage;
  }

  languageChange() {
    console.warn('Language', this.selectedLanguage);
    this._translateService.use(this.selectedLanguage);
  }
}
